export const TRADING_OFFERS_PAGE_SIZE = 100;
export const TRADING_OFFERS_FILTERS: string[] = [];
